"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmationModal = void 0;
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _react = _interopRequireDefault(require("react"));
var _button = require("../../button");
var _proLightSvgIcons = require("@fortawesome/pro-light-svg-icons");
var _core = require("@material-ui/core");
var _Modal = require("../Modal");
var _ConfirmationModal = require("./ConfirmationModal.styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ConfirmationModal = function ConfirmationModal(_ref) {
  var title = _ref.title,
    exitButtonText = _ref.exitButtonText,
    confirmButtonText = _ref.confirmButtonText,
    open = _ref.open,
    onConfirm = _ref.onConfirm,
    onExit = _ref.onExit,
    content = _ref.content,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'negative' : _ref$variant,
    confirmIcon = _ref.confirmIcon,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    buttonSpacing = _ref.buttonSpacing,
    bothButtons = _ref.bothButtons,
    width = _ref.width,
    actionModal = _ref.actionModal,
    confirmButtonWidth = _ref.confirmButtonWidth,
    cancelButtonWidth = _ref.cancelButtonWidth;
  var classes = (0, _ConfirmationModal.useStyles)({
    width: width,
    actionModal: actionModal
  });
  return /*#__PURE__*/_react["default"].createElement(_Modal.Modal, {
    className: classes.root,
    open: open,
    paperClassName: classes.modal
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    padding: "28px 32px",
    position: "relative",
    style: {
      width: '44px',
      "float": 'right',
      zIndex: '2'
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    onClick: onExit,
    className: classes.closeButton
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _proLightSvgIcons.faTimes,
    size: "sm"
  }))), title ? /*#__PURE__*/_react["default"].createElement(_core.Box, {
    padding: "28px 32px",
    position: "relative",
    style: {
      borderBottom: title ? '#f7f7f7 solid 1px' : undefined,
      zIndex: '1'
    }
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: classes.title
  }, title)) : undefined, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.content
  }, /*#__PURE__*/_react["default"].createElement("p", null, content)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.buttons,
    style: {
      justifyContent: buttonSpacing || 'flex-end'
    }
  }, bothButtons ? /*#__PURE__*/_react["default"].createElement(_button.BaseButton, {
    testId: "modal-exit-button",
    variant: "contained",
    onClick: onExit,
    className: classes.cancelButton,
    style: {
      width: cancelButtonWidth
    }
  }, exitButtonText) : null, variant === 'negative' ? /*#__PURE__*/_react["default"].createElement(_button.BaseButton, {
    testId: "modal-confirm-button",
    disabled: disabled,
    startIcon: confirmIcon ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: confirmIcon
    }) : null,
    className: classes.confirmButton,
    variant: "contained",
    onClick: onConfirm,
    style: {
      width: confirmButtonWidth
    }
  }, confirmButtonText) : /*#__PURE__*/_react["default"].createElement(_button.ActionButton, {
    testId: "modal-confirm-button",
    disabled: disabled,
    startIcon: confirmIcon ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: confirmIcon
    }) : null,
    onClick: onConfirm,
    style: {
      width: confirmButtonWidth
    }
  }, confirmButtonText))));
};
exports.ConfirmationModal = ConfirmationModal;